/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import { fireErrorAnalytics as fireJiraErrorAnalytics } from '@jira/platform__error-reporting/src/fireErrorAnalytics.tsx';
import type { AnalyticsEventPayload } from '@atlaskit/analytics-next/AnalyticsEvent';
import type UIAnalyticsEvent from '@atlaskit/analytics-next/UIAnalyticsEvent';
import {
	fireTrackAnalytics,
	type AnalyticsAttributes,
} from '@atlassian/jira-product-analytics-bridge';
import type { CrossJoinIntegration } from '../../common/types.tsx';

export type CreateAnalyticsEvent = (payload: AnalyticsEventPayload) => UIAnalyticsEvent;

export const fireErrorAnalytics = (
	id: string,
	error: Error,
	attributes: AnalyticsAttributes = {},
): Promise<void> =>
	fireJiraErrorAnalytics({
		meta: {
			id,
			packageName: 'jiraCrossJoinNudges',
			teamName: 'puma',
		},
		attributes,
		error,
		sendToPrivacyUnsafeSplunk: true,
	});

export const fireSiteOptedOutAnalytics = (
	createAnalyticsEvent: CreateAnalyticsEvent,
	integration: CrossJoinIntegration,
): void => {
	fireTrackAnalytics(createAnalyticsEvent({}), 'eligibility checked', {
		flagKey: 'NON_CONTEXTUAL_CJNS',
		ineligibilityReason: 'SITE_OPTED_OUT',
		integration,
	});
};

export const fireMsrNotRecommendedAnalytics = (
	createAnalyticsEvent: CreateAnalyticsEvent,
	integration: CrossJoinIntegration,
	nudgeId: string,
): void => {
	fireTrackAnalytics(createAnalyticsEvent({}), 'eligibility checked', {
		flagKey: 'NON_CONTEXTUAL_CJNS',
		ineligibilityReason: 'MSR_NOT_RECOMMENDED',
		integration,
		nudgeId,
	});
};

export const fireCjnNav4PlacementExposed = (
	createAnalyticsEvent: CreateAnalyticsEvent,
	actionSubject: string,
	flagKey: string,
	cohort: string,
	targetProduct: 'jira_productDiscovery' | 'confluence' | 'loom',
): void => {
	fireTrackAnalytics(createAnalyticsEvent({}), `${actionSubject} exposed`, {
		flagKey,
		cohort,
		targetProduct,
	});
};
